import { observer } from 'mobx-react-lite';
import { PasswordField, SavingIndicator, TextField } from '../../../components';
import type S3Storage from '../store/services/storages/S3Storage';

export default observer(function S3StorageForm({
  storage,
}: {
  storage: S3Storage;
}) {
  return (
    <>
      <TextField
        errorText={storage.errors.apiKey}
        label="Access Key ID"
        name="apiKey"
        onBlur={storage.handleBlur}
        onChange={storage.handleChange}
        required
        sx={{ width: '80%' }}
        value={storage.apiKey}
      />
      <PasswordField
        errorText={storage.errors.apiSecret}
        label="Secret Access Key"
        name="apiSecret"
        onBlur={storage.handleBlur}
        onChange={storage.handleChange}
        required
        sx={{ width: '80%' }}
        value={storage.apiSecret}
      />

      <SavingIndicator indicator={storage.indicator} sx={{ mt: 2 }} />
    </>
  );
});
